import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";

var _reducerMap;

import { handleActions } from 'redux-actions';
import actions from '../actions/cart';
export var name = 'cart';
export var initialState = {
  addItemError: null,
  cartId: null,
  details: {},
  detailsError: null,
  getCartError: null,
  isLoading: false,
  isUpdatingItem: false,
  isAddingItem: false,
  removeItemError: null,
  shippingMethods: [],
  updateItemError: null
};
var reducerMap = (_reducerMap = {}, _defineProperty(_reducerMap, actions.getCart.receive, function (state, _ref) {
  var payload = _ref.payload,
      error = _ref.error;

  if (error) {
    return _objectSpread({}, initialState, {
      getCartError: payload
    });
  }

  return _objectSpread({}, state, {
    cartId: String(payload),
    getCartError: null
  });
}), _defineProperty(_reducerMap, actions.getDetails.request, function (state) {
  return _objectSpread({}, state, {
    isLoading: true
  });
}), _defineProperty(_reducerMap, actions.getDetails.receive, function (state, _ref2) {
  var payload = _ref2.payload,
      error = _ref2.error;

  if (error) {
    return _objectSpread({}, state, {
      detailsError: payload,
      isLoading: false
    });
  }

  return _objectSpread({}, state, payload, {
    isLoading: false
  });
}), _defineProperty(_reducerMap, actions.addItem.request, function (state) {
  return _objectSpread({}, state, {
    isAddingItem: true
  });
}), _defineProperty(_reducerMap, actions.addItem.receive, function (state, _ref3) {
  var payload = _ref3.payload,
      error = _ref3.error;

  if (error) {
    return _objectSpread({}, state, {
      addItemError: payload,
      isAddingItem: false
    });
  }

  return _objectSpread({}, state, {
    isAddingItem: false
  });
}), _defineProperty(_reducerMap, actions.updateItem.request, function (state) {
  return _objectSpread({}, state, {
    isUpdatingItem: true
  });
}), _defineProperty(_reducerMap, actions.updateItem.receive, function (state, _ref4) {
  var payload = _ref4.payload,
      error = _ref4.error;

  if (error) {
    return _objectSpread({}, state, {
      isUpdatingItem: false,
      updateItemError: payload
    });
  } // We don't actually have to update any items here
  // because we force a refresh from the server.


  return _objectSpread({}, state, {
    isUpdatingItem: false
  });
}), _defineProperty(_reducerMap, actions.removeItem.receive, function (state, _ref5) {
  var payload = _ref5.payload,
      error = _ref5.error;

  if (error) {
    return _objectSpread({}, state, {
      removeItemError: payload
    });
  }

  return _objectSpread({}, state);
}), _defineProperty(_reducerMap, actions.reset, function () {
  return initialState;
}), _reducerMap);
export default handleActions(reducerMap, initialState);